import { InboxSectionEnum, MessageState } from '../models/Inbox'

export const messageStateConvertToReadable = (state: MessageState): string => {
  switch (state) {
    case MessageState.Received:
      return 'Innboks'
    case MessageState.Sent:
      return 'Sendt'
    case MessageState.Processed:
      return 'Behandlet'
    case MessageState.Draft:
      return 'Utkast'
    case MessageState.Deleted:
      return 'Slettet'
    case MessageState.PermanentlyDeleted:
      return 'Permanent slettet'
    default:
      return ''
  }
}

export const messageStateToInboxSectionEnum = (
  state: MessageState
): InboxSectionEnum => {
  switch (state) {
    case MessageState.Received:
      return InboxSectionEnum.Received
    case MessageState.Sent:
      return InboxSectionEnum.Sent
    case MessageState.Processed:
      return InboxSectionEnum.Processed
    case MessageState.Draft:
      return InboxSectionEnum.Draft
    case MessageState.Deleted:
      return InboxSectionEnum.Deleted
    case MessageState.PermanentlyDeleted:
      return InboxSectionEnum.All
    default:
      return InboxSectionEnum.Received
  }
}
